import { Card, Stack, TextField, Typography } from "@mui/material";
import { DataGrid, GridColDef, GridFilterItem, GridRenderCellParams, GridSortDirection } from "@mui/x-data-grid";
import React, { useState } from "react";
import { Payment, useFetchPaymentsQuery } from "../paymentsApi";
import { Link } from "react-router";

const columns: GridColDef<Payment>[] = [
  { field: "id", headerName: "ID", width: 90, filterable: false },
  {
    field: "identifier",
    headerName: "Identifier",
    width: 150,
    filterable: false,
  },
  {
    field: "payProvider",
    headerName: "Provider",
    width: 150,
    filterable: false,
  },
  {
    field: "vestiging_id",
    headerName: "Salesarea",
    width: 150,
    filterable: false,
    renderCell: (params: GridRenderCellParams<Payment>) => (
      <Link to={"/manager/vestigingen/" + params.value + "/edit"}>
        {params.row.vestiging?.systeemNaam ?? "Deleted"}
      </Link>
    ),
  },
  {
    field: "payMethod",
    headerName: "Method",
    width: 110,
    filterable: false,
  },
  {
    field: "created_at",
    headerName: "Date",
    width: 110,
    filterable: false,
  },
  {
    field: "amount",
    headerName: "Amount",
    width: 110,
    filterable: false,
    sortable: false,
  },
  {
    field: "bestelling_id",
    headerName: "Order ID",
    width: 110,
    filterable: false,
    sortable: false,
  },
];

export default function PaymentsPage() {
  const [sortModel, setSortModel] = useState<{ field: string; sort: GridSortDirection }[]>([]);
  const [gridFilterItems, setGridFilterItems] = useState<Record<string, GridFilterItem>>({});
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const { data, isFetching } = useFetchPaymentsQuery({
    // identifier: { values: ["VIOMB7WWG"] },
    gridFilterItems,
    pagination: { page: page + 1, perPage: pageSize },
    sorting: sortModel,
  });

  return (
    <Card sx={{ my: 3, p: 2 }}>
      <Stack gap={3}>
        <Typography>Payments/Vouchers</Typography>
        <Stack direction={"row"} gap={3}>
          <TextField
            label={"Identifier"}
            onChange={(e) => {
              const newGridFilterItems = { ...gridFilterItems };
              if (e.target.value) {
                newGridFilterItems["identifier"] = { field: "identifier", value: e.target.value, operator: "=" };
              } else {
                delete newGridFilterItems["identifier"];
              }
              setGridFilterItems(newGridFilterItems);
            }}
            value={gridFilterItems["identifier"]?.value ?? ""}
          />
        </Stack>

        <DataGrid
          columns={columns}
          filterMode={"server"}
          initialState={{ pagination: { paginationModel: { page, pageSize } } }}
          loading={isFetching}
          onPaginationModelChange={(newPaginationModel) => {
            console.log(newPaginationModel);
            setPage(newPaginationModel.page);
            setPageSize(newPaginationModel.pageSize);
            // fetch data from server
          }}
          pageSizeOptions={[10, 25, 50, 100]}
          pagination
          paginationMode={"server"}
          rowCount={data?.meta?.total}
          rows={data?.data ?? []}
          sortingMode={"server"}
          onSortModelChange={(newSortModel) => {
            // fetch data from server
            console.log(newSortModel);
            setSortModel(newSortModel);
          }}
          // onFilterModelChange={(newFilterModel) => {
          //   console.log(newFilterModel);
          //   newFilterModel.items;
          //   setGri;
          //   // fetch data from server
          // }}
        />
      </Stack>
    </Card>
  );
}
